import { latexExportsJson } from "@corca/data/latex-exports";

import type { LocaleKeywords } from "@corca/data";

export function appendLatexKeywords(
  key: string | undefined,
  localeKeywords: LocaleKeywords,
): LocaleKeywords {
  if (!key) return localeKeywords;
  const latexExports = latexExportsJson[key];
  if (!latexExports) return localeKeywords;

  const enKeywords = localeKeywords.en;
  const latexKeywords: LocaleKeywords["en"] = {};

  if (latexExports.exports) {
    const command = latexExports.exports.split("{")[0]?.trim();
    if (command && !enKeywords[command]) {
      latexKeywords[command] = 1;
    }
  }

  if (latexExports.imports) {
    for (const cmd of latexExports.imports) {
      const command = cmd.split("{")[0]?.trim();
      if (command && !enKeywords[command]) {
        latexKeywords[command] = 1;
      }
    }
  }

  if (Object.keys(latexKeywords).length === 0) return localeKeywords;

  return {
    ...localeKeywords,
    en: { ...enKeywords, ...latexKeywords },
  };
}
